import React from 'react'
import TempOverview from '../Explore/TempOverview'

function Tempoverview() {
  return (
    <>
        <TempOverview />
    </>
  )
}

export default Tempoverview
